module.exports = __webpack_public_path__ + "static/media/logo.e9d5ee09.jpg";